// extracted by mini-css-extract-plugin
export default {"wrapper":"BreadCrumbs_wrapper__TcZYD","link":"BreadCrumbs_link__Rsqz8"};